import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { getTranslations as getTranslationsApi } from "../../helpers/backend_helper";

//getTranslations
export const getTranslations = createAsyncThunk(
  "translations/getTranslations",
  async (languageCode: any) => {
    try {
      const response = getTranslationsApi(languageCode || "en-US");
      return response;
    } catch (error) {
      return error;
    }
  },
);
